import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "speed",
  standalone: false,
})
export class SpeedConversionsPipe implements PipeTransform {
  transform(value: number, conversionUnits: string, digits?: number, showUnits?: boolean): string {
    if (!value && value !== 0) {
      return "Unavailable";
    }

    let result;
    switch (conversionUnits) {
      case "mph-km/h":
        result = value * 1.609;
        break;
      case "km/h-mph":
        result = value / 1.609;
        break;

      default:
        result = value;
    }

    if (digits || digits === 0) {
      result = result.toFixed(digits);
    }

    if (showUnits && conversionUnits) {
      result += ` ${conversionUnits.split("-")[1]}`;
    }

    return result;
  }
}
